import axios from "axios";
import * as constants from "../theme/constants";

const baseURL = constants.apiBaseUrl;
export const httpClient = axios.create({
  baseURL: baseURL, //YOUR_API_URL HERE
  headers: {
    "Content-Type": "application/json",
  },
});

// import axios from 'axios';

// export const httpClient = axios.create({
//   baseURL: `http://g-axon.work/jwtauth/api/`, //YOUR_API_URL HERE
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });
